// extracted by mini-css-extract-plugin
module.exports = {"root":"TagCloudBlok_root__awfZ_","header":"TagCloudBlok_header__A0qPm","items":"TagCloudBlok_items__nnisI"};